module.exports = __webpack_public_path__ + "components/homepage-hero/static/hero-bg-full-6fcbd42847c834e40929b6826aaf8d61.jpg";